var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.167 12.5v1.667a1.667 1.667 0 001.541 1.662l.125.004h2.5V17.5h-2.5A3.333 3.333 0 012.5 14.167V12.5h1.667zm10-10A3.333 3.333 0 0117.5 5.833V7.5h-1.667V5.833a1.667 1.667 0 00-1.666-1.666h-2.5V2.5h2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.333l3.667 9.167H16.87L15.87 15h-3.408l-1 2.5H9.668l3.665-9.167H15zm-.833 2.405l-1.04 2.595h2.077l-1.037-2.595z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.666 1.667v1.666h3.333v5.834H6.666v2.5H4.999v-2.5H1.666V3.333h3.333V1.667h1.667zM4.999 5H3.333v2.5h1.666V5zm3.334 0H6.666v2.5h1.667V5z",
    fill: "#AFB7C2"
  })));
}
export default SvgEnS;